// extracted by mini-css-extract-plugin
export default {"underConstructionFallback":"zyRea6C5YtAEsO5apl2Y","fallbackTitle":"M8XtWITjUcn3PxHsZiRU","fallbackDescription":"eb6go7lwNTyE3ezU2pIJ"};